export default __webpack_public_path__ + "static/media/pic8.f7537ca7.jpg";